<template>
  <div class="m-pop">
    <p class="x-font-color">报考信息</p>
    <van-form @submit="submitClaim" ref="fromRef">
      <template v-for="(item,index) in fieldArray">
        <template v-if="item.type==='text'">
          <van-field v-model="fieldObj[item.nameKey]" @blur="blur" :label="item.showName" :placeholder="'请输入'+item.showName"
                     :rules="item.required ? [{ required: true, message: '请输入' }] : []" :required="item.required"/>
        </template>
        <template v-if="item.type==='drop'">
          <van-field is-link :label="item.showName" placeholder="请选择" readonly
                     :rules="item.required ? [{ required: true, message: '请选择' }] : []" :required="item.required"
                     v-model="fieldObj[item.nameKey+'Name']"
                     @click="item.multiple==true ? dropDownChooseObj[item.nameKey] = true : dropDownObj[item.nameKey]=true"/>
        </template>
        <template v-if="item.type==='date'">
          <van-field is-link :label="item.showName" placeholder="请选择" readonly
                     :rules="item.required ? [{ required: true, message: '请选择' }] : []" :required="item.required"
                     v-model="fieldObj[item.nameKey]" @click="dateObj[item.nameKey]=true"/>
        </template>
        <template v-if="item.type==='file'">
          <van-field class="m-file-field" v-model="fieldObj[item.nameKey]" :label="item.showName"
                     :rules="item.required ? [{ required: true, message: '请上传' }] : []" :required="item.required">
            <template #input>
              <div v-show="fieldObj[item.nameKey]" class="m-photo">
                <img class="m-img-cover" :src="fieldObj[item.nameKey]" alt="">
                <van-icon class="m-delete-o" name="delete-o" @click="delPhoto(item.nameKey)"/>
              </div>

              <van-uploader v-show="!(fieldObj[item.nameKey])" class="m-upload" accept="image/*" :capture="false"
                            :multiple="true" :max-count="1"
                            :before-read="beforeRead"
                            :after-read="(e)=>afterRead(e,item.nameKey)">
                <div class="m-upload-box">
                  <van-icon class="m-plus" name="plus"/>
                  <span>请上传</span>
                </div>
              </van-uploader>
            </template>
          </van-field>
        </template>
      </template>
    </van-form>
    <!--单选下拉框-->
    <template v-for="(item,key,index) of dropDownObj">
      <van-popup v-model="dropDownObj[key]" position="bottom" :close-on-click-overlay="false" :style="{width: '100%'}">
        <van-picker value-key="label" show-toolbar @confirm="(value)=>onConfirmDropdown(value,key)"
                    @cancel="dropDownObj[key]=false" :columns="handleData(dropDownTempObj[key])"/>
      </van-popup>
    </template>
    <!--多选下拉框-->
    <template v-for="(item,key) of dropDownChooseObj">
      <van-popup class="m-chose" v-model="dropDownChooseObj[key]" position="bottom" round :style="{ height: '45%' }"
                 :close-on-click-overlay="false">
        <div class="m-title">
          <div style="color: #969799" @click="isNo(key)">取消</div>
          <div></div>
          <div style="color: #576b95" @click="confirmOk(key,handleData(dropDownTempObj[key]))">确认</div>
        </div>
        <div class="m-pop-content">
          <van-checkbox-group v-model="resultObj[key]">
            <van-cell-group>
              <van-cell v-for="(item, index) in handleData(dropDownTempObj[key])" clickable :title="item.label"
                        :key="item.value" @click="toggle(index,key)">
                <template #right-icon>
                  <van-checkbox :name="item.value" :ref="'checkboxes'+key"/>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </van-popup>
    </template>
    <!--日历-->
    <template v-for="(item,key) of dateObj">
      <van-popup v-model="dateObj[key]" position="bottom" :close-on-click-overlay="false" :style="{width: '100%'}">
        <van-datetime-picker type="date" title="选择年月日" :min-date="new Date(1960, 0, 1)" :max-date="new Date(2280, 0, 1)"
                             @confirm="(value)=>onConfirmTime(value,key)" @cancel="dateObj[key] = false"/>
      </van-popup>
    </template>
  </div>
</template>

<script>
  import { nationArr } from '@/utils/nation'

  export default {
    components: {},
    props: {
      templateId: {
        type: [String, Number],
        default: ''
      }
    },
    data () {
      return {
        fieldArray: [],
        formDataArray: [
          {nameKey: 'username', showValue: '', showName: '姓名', type: 'text', required: true, multiple: false, templateList: []},
          {nameKey: 'sex', showValue: '', showName: '性别', type: 'drop', required: true, multiple: false, templateList: []},
          {nameKey: 'idCardNumb', showValue: '', showName: '身份证号', type: 'text', required: true, multiple: false, templateList: []},
          {nameKey: 'birthDay', showValue: '', showName: '出生日期', type: 'date', required: true, multiple: false, templateList: []},
          {nameKey: 'nation', showValue: '', showName: '民族', type: 'drop', required: true, multiple: false, templateList: []},
          {nameKey: 'position', showValue: '', showName: '职级', type: 'drop', required: true, multiple: false, templateList: []},
          {nameKey: 'maxEdu', showValue: '', showName: '最高学历', type: 'drop', required: true, multiple: false, templateList: []},
          {nameKey: 'eduMajor', showValue: '', showName: '学历专业', type: 'text', required: true, multiple: false, templateList: []},
          {nameKey: 'personnelNature', showValue: '', showName: '人员性质', type: 'drop', required: true, multiple: false, templateList: []},
          {nameKey: 'hasLawSeniority', showValue: '', showName: '是否具有法律职业资格证书', type: 'drop', required: true, multiple: false, templateList: []},
          {nameKey: 'politicalOutlook', showValue: '', showName: '政治面貌', type: 'drop', required: true, multiple: false, templateList: []},
          {nameKey: 'idCardPhoto', showValue: '', showName: '证件照', type: 'file', required: true, multiple: false, templateList: []}
        ],
        fieldObj: {},
        dropDownObj: {},
        dropDownChooseObj: {},
        dropDownTempObj: {},
        dropDownMap: new Map(),
        resultObj: {},
        dateObj: {},
//        form:{},
        userInfoExtPO: []
      }
    },
    created () {
      if (this.$route.query.id) {
        this.getFormData()
      } else {
        this.getJsonSet()
      }
    },
    methods: {
      blur(){this.$forceUpdate()},
      submitClaim () {
        this.$refs.fromRef.validate().then(() => {}).catch(() => {})
      },
      SetArray () {
        this.fieldArray.forEach((item) => {
          if (item.type === 'drop') {
            this.$set(this.fieldObj, item.nameKey, item.showValue)
            this.$set(this.dropDownTempObj, item.nameKey, item.nameKey)
            this.dropDownMap.set(item.nameKey, item.templateList)
            if (item.multiple == true) {
              this.$set(this.dropDownChooseObj, item.nameKey, false) // 多选弹出层全部先隐藏
              this.$set(this.resultObj, item.nameKey, item.showValue ? item.showValue.split(',') : [])
            } else {
              this.$set(this.dropDownObj, item.nameKey, false) // 弹出层全部先隐藏
            }
          } else if (item.type === 'date') {
            this.$set(this.fieldObj, item.nameKey, item.showValue)
            this.$set(this.dateObj, item.nameKey, false) //弹出层全部先隐藏
          }
        })
        if (this.$route.query.id) {
          this.assignSet()
        }
      },
      onConfirmDropdown (value, key) { // 下拉框选中数据
        this.dropDownObj[key] = false
        this.fieldObj[key] = value.value
        this.fieldObj[key + 'Name'] = value.label
      },
      handleData (key) { // 下拉框获取每一个配置项
        return this.dropDownMap.get(key)
      },
      isNo (key) {
        this.dropDownChooseObj[key] = false
        this.fieldObj[key] = ''
        this.fieldObj[key + 'Name'] = ''
        this.resultObj[key] = []
      },
      confirmOk (key, arrList) {
        let str = ''
        let arr = []
        this.resultObj[key].forEach((item) => {
          arrList.forEach((ite) => {
            if (item == ite.value) {
              if (str) {
                str = str + ',' + ite.label
              } else {
                str = str + ite.label
              }
              arr.push(item)
            }
          })
        })
        this.fieldObj[key] = arr.join(',')
        this.fieldObj[key + 'Name'] = str
        console.log(str)
        this.dropDownChooseObj[key] = false
      },
      toggle (index, key) {
        this.$refs['checkboxes' + key][index].toggle()
      },
      onConfirmTime (value, key) {  // 日历控件
        this.dateObj[key] = false
        this.fieldObj[key] = this.dayjs(value).format('YYYY-MM-DD')
      },
      beforeRead(e){
        if(e.length>1){
          this.utils.toastError('只能选择一张图片上传！')
          return false
        }
        if(e.size>20971520){
          this.utils.toastError('文件大小不能超过20MB！')
          return false
        }
        return true
      },
      afterRead (e, key) {
        let msg = new FormData()
        msg.append('file', e.file)
        this.http.postRequest({
          headers: {'Content-Type': 'multipart/form-data'},
          url: 'app/common/upload',
          msg: msg,
          special: true
        }, true).then((res) => {
          if (res.code == 200) {
            this.$set(this.fieldObj, key, res.url)
            this.$forceUpdate()
          } else {
            this.utils.toastNone(res.msg || res.code)
          }
        }, true)
      },
      getJsonSet () {
        this.http.getRequest({
          url: 'app/exam/getTemplateInfoById',
          msg: {id: this.templateId},
          success: (res) => {
            let bol = res.data && res.data.registerTemplatePickList && res.data.registerTemplatePickList.length
            if (bol > 0) {
              let registerTemplatePickList = res.data.registerTemplatePickList
              registerTemplatePickList.forEach((item) => {
                let obj = this.formDataArray.find((child) => {
                  return (child.nameKey == item.name && item.hasShow == 1)
                })
                if(obj) {
                  obj.multiple = item.hasMultiple == 1 ? true : false
                  if (obj.nameKey == 'nation') {
                    obj.templateList = nationArr()
                  } else {
                    obj.templateList = (item.registerTemplateOptionList && item.registerTemplateOptionList.length > 0) ? item.registerTemplateOptionList : []
                  }
                  obj.required = item.hasRequired == 1 ? true : false
                  this.fieldArray.push(obj)
                }
              })
              this.SetArray()
            }
          }
        })
      },
      delPhoto (key) {
        this.$set(this.fieldObj, key, '')
        this.$forceUpdate()
      },
      //获取动态表单回显信息
      getFormData () {
        this.http.getRequest({
          url: `app/exam/findRegisterInfoToModify/${this.$route.query.id}`,
          msg: {},
          success: (res) => {
            this.getJsonSet()
            if (res.data) {
              this.userInfoExtPO = res.data.userInfoExtPO ? res.data.userInfoExtPO : {}
            }
          }
        })
      },
      assignSet () {
        this.fieldArray.forEach((item) => {
          if (item.type == 'text' || item.type == 'file') {
            this.fieldObj[item.nameKey] = this.userInfoExtPO[item.nameKey] ? this.userInfoExtPO[item.nameKey] : ''
          }
          if(item.type == 'date'){
            this.fieldObj[item.nameKey] = this.userInfoExtPO[item.nameKey] ? this.dayjs(this.userInfoExtPO[item.nameKey]).format('YYYY-MM-DD')  : ''
          }
          if(item.type == 'drop'){
            this.fieldObj[item.nameKey] = this.userInfoExtPO[item.nameKey] ? this.userInfoExtPO[item.nameKey] : ''
            let numStr = this.fieldObj[item.nameKey]
            if(numStr){
              let numArr = numStr.split(',')
              let dataArr = item.templateList
              if(item.multiple){
                this.resultObj[item.nameKey] = numArr     
              }
              if(numArr.length==1){
                let strObj =  dataArr.find((sml)=>{
                  return  sml.value == numArr[0]
                })
                this.fieldObj[item.nameKey+'Name'] = strObj.label
              }
              if(numArr.length>1){
                let montageStr = ''
                numArr.filter((t)=>{
                  let obs = dataArr.find((i)=>{
                    return t == i.value
                  })
                  if(montageStr){
                    montageStr= montageStr + "," +obs.label
                  }else{
                    montageStr= montageStr + obs.label
                  }
                })
                this.fieldObj[item.nameKey+'Name'] = montageStr
              }
            }
          }
        })
      },
    },
    mounted () {
     
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";

  .m-pop {
    .x-font-color {
      font-weight: 600;
    }
    .van-cell--required::before {
      left: 0px;
      font-size: 18px;
    }
    /deep/ .van-field__label {
      color: #8D8F93 !important;
    }
    /deep/ .van-field__error-message {
      text-align: right;
    }
    .van-cell {
      padding: 0 0 0 8px;
      margin-top: 20px;
    }
    .van-cell::after {
      display: none;
    }
    /deep/ .van-field__control {
      text-align: right;
    }
    /deep/ .van-field__control::placeholder {
      color: #8D8F93 !important;
    }
    .m-chose {
      .van-cell {
        padding: 10px !important;
        margin-top: 0px;
      }
    }
    .m-title {
      left: 0;
      right: 0;
      position: absolute;
      display: flex;
      height: 65px;
      > div:nth-child(1), div:nth-child(3) {
        font-size: 14px;
        padding: 0 16px;
        line-height: 65px;
      }
      > div:nth-child(2) {
        flex: 1;
        text-align: center;
        line-height: 65px;
        font-size: 16px;
      }
    }
    .m-pop-content {
      position: absolute;
      left: 0;
      right: 0;
      top: 60px;
      bottom: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 100;
      background: #ffffff;
    }
    .m-file-field {
      .m-photo {
        display: flex;
        align-items: center;
        .m-delete-o {
          font-size: 20px;
          color: red;
        }
        .m-img-cover {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }
      }
      /deep/ .van-field__control {
        display: flex;
        justify-content: end;
      }
      .m-upload {
        .m-upload-box {
          width: 80px;
          height: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #FAFAFA;
          .m-plus {
            font-size: 20px;
            color: #B7B7B7;
          }
          > span {
            margin-top: 5px;
            font-size: 13px;
            color: #B7B7B7;
          }
        }
      }
    }

  }
</style>

